import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../zustand/ThemeStore';
import { useEffect } from 'react';

export default function TermsOfService() {
  const navigate = useNavigate();
  const isDarkMode = useTheme((state) => state.theme);

  useEffect(() => {
    // Load Termly script dynamically
    const script = document.createElement('script');
    script.innerHTML = `
        (function(d, s, id) {
            var js, tjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = "https://app.termly.io/embed-policy.min.js";
            tjs.parentNode.insertBefore(js, tjs);
        }(document, 'script', 'termly-jssdk'));
    `;
    
    // Check if script is already loaded
    if (!document.getElementById('termly-jssdk')) {
        document.body.appendChild(script);
    }

    // Cleanup function to remove script when component unmounts
    return () => {
        const existingScript = document.getElementById('termly-jssdk');
        if (existingScript) {
            existingScript.remove();
        }
    };
  }, []);

  return (
    <div className={`min-h-screen transition-colors duration-500 ${
      isDarkMode ? 'bg-black' : 'bg-gray-50'
    }`}>
      {/* Header with Back Button */}
      <div className={`border-b ${isDarkMode ? 'border-[#1a2424]' : 'border-gray-200'}`}>
        <div className="max-w-4xl mx-auto px-4 py-6">
          <button
            onClick={() => navigate(-1)}
            className={`flex items-center gap-2 text-sm font-medium hover:text-[#1a9f6b] transition-colors ${
              isDarkMode ? 'text-gray-300' : 'text-gray-600'
            }`}
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className={`${
          isDarkMode ? 'bg-[#0a1414] border-[#1a2424]' : 'bg-white border-gray-200'
        } rounded-lg border shadow-lg p-8`}>
          <h1 className={`text-3xl font-bold mb-8 ${
            isDarkMode ? 'text-white' : 'text-[#053333]'
          }`}>
            Terms of Service
          </h1>
          
          <div className={`space-y-6 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-700'
          }`}>
            <div className={`rounded-lg ${
              isDarkMode ? 'border-[#1a2424] bg-[#050a0a]' : 'border-gray-300 bg-gray-50'
            }`}>
              <div className='bg-white'
                dangerouslySetInnerHTML={{
                  __html: '<div name="termly-embed" data-id="4733d462-3108-4394-9187-f0ec0650e116" data-type="iframe"></div>'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}